import { useQuery } from '@tanstack/react-query';
import { OWASReportService } from '@/infra/services/owas-report';
import { OWAS_QUERY_KEYS } from '../enums';

const Service = OWASReportService.getInstance();

export const useGetOwasCategories = () => {
	return useQuery([OWAS_QUERY_KEYS.GET_CATEGORIES], () => Service.getCategoryParts());
};
